import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import yup from '../../libs/yup/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TextInput from '../../components/form/TextInput';
import SingleImageUploader from '../../components/form/SingleImageUploader';
import { getPacakgeDetail, updatePackage } from '../../api/sportaloka-client';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';

const defaultValues = {
  name_id: '',
  name_en: '',
  description_id: '',
  description_en: '',
  local_price: 0,
  foreign_price: 0,
  image: ''
};

const schema = yup.object().shape({
  name_id: yup.string().label('Nama Paket Wisata (ID)').required('${label} wajib diisi'),
  name_en: yup.string().label('Nama Paket Wisata (EN)').required('${label} wajib diisi'),
  description_id: yup.string().label('Deskripsi (ID)').required('${label} wajib diisi'),
  description_en: yup.string().label('Deskripsi (EN)').required('${label} wajib diisi'),
  local_price: yup
    .number('${label} harus berupa angka')
    .label('Harga Wisatawan Lokal')
    .typeError('Harus berupa angka')
    .required('${label} wajib diisi'),
  foreign_price: yup
    .number('${label} harus berupa angka')
    .label('Harga Wisatawan Asing')
    .typeError('Harus berupa angka')
    .required('${label} wajib diisi'),
  image: yup.string().label('Gambar Paket').required('${label} wajib diisi')
});

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ size: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ script: 'sub' }, { script: 'super' }],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    ['link', 'image', 'video'],
    ['clean']
  ]
};

const DetailPackage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [id, setId] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(false);
  const [initError, setInitError] = useState(false);

  const form = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await updatePackage(id, val);
      navigate('/packages');
      Swal.fire({
        title: 'Berhasil!',
        text: `Paket berhasil diperbarui`,
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    } catch (error) {
      Swal.fire({
        title: 'Gagal!',
        text: `Periksa koneksi internet anda dan coba kembali`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  const getData = async () => {
    try {
      setInitError(false);
      setInitLoading(true);
      const response = await getPacakgeDetail(slug);
      const responseData = response.data.data;
      setId(responseData.id);
      form.setValue('name_id', responseData.name_id);
      form.setValue('name_en', responseData.name_en);
      form.setValue('description_id', responseData.description_id);
      form.setValue('description_en', responseData.description_en);
      form.setValue('local_price', responseData.local_price);
      form.setValue('foreign_price', responseData.foreign_price);
      form.setValue('image', responseData.image);
      setInitLoading(false);
    } catch (error) {
      setInitError(true);
      setInitLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-30 lh-14 fw-600">Detail Paket</h1>
            {!initLoading && (
              <div className="d-flex">
                <Link to="/packages" className="button -md bg-white h-50 text-dark mr-20">
                  <i className="fa fa-arrow-left mr-10" />
                  Kembali
                </Link>

                <button disabled={loading} className="button -md bg-blue-1 h-50 text-white">
                  {!loading && <i className="fa fa-save text-16 mr-10" />}
                  {loading ? 'Menyimpan...' : 'Simpan Perubahan'}
                </button>
              </div>
            )}
          </div>
          <div
            className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20 d-flex align-items-center justify-content-center"
            style={{ minHeight: 540 }}>
            {initLoading && !initError && (
              <div className="d-flex justify-content-center align-items-center h-100">
                <p className="fw-500 text-dark my-auto">Memuat...</p>
              </div>
            )}
            {!initLoading && initError && (
              <div className="d-flex justify-content-center align-items-center h-100">
                <p className="fw-500 text-dark my-auto text-center">
                  Tidak dapat melakukan permintaan, periksa koneksi internet anda dan{' '}
                  <p className="text-danger fw-600 cursor-pointer" onClick={getData}>
                    coba kembali
                  </p>
                </p>
              </div>
            )}
            {!initLoading && !initError && (
              <div className="row">
                <div className="col-6">
                  <Controller
                    control={form.control}
                    name="name_id"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextInput
                        disabled={loading}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        type="text"
                        isRequired={true}
                        label="Nama Paket Wisata (ID)"
                        isError={Boolean(form.formState.errors.name_id)}
                        errorMessage={
                          Boolean(form.formState.errors.name_id) &&
                          form.formState.errors.name_id.message
                        }
                      />
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={form.control}
                    name="name_en"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextInput
                        disabled={loading}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        type="text"
                        isRequired={true}
                        label="Nama Paket Wisata (EN)"
                        isError={Boolean(form.formState.errors.name_en)}
                        errorMessage={
                          Boolean(form.formState.errors.name_en) &&
                          form.formState.errors.name_en.message
                        }
                      />
                    )}
                  />
                </div>
                <div className="col-12">
                  <Controller
                    control={form.control}
                    name="description_id"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <div style={{ marginBottom: 42 }}>
                        <label className="fw-600 text-dark">
                          Deskripsi (ID) <span className="text-danger">*</span>
                        </label>
                        <ReactQuill
                          className={`${Boolean(form.formState.errors.description_id) && 'form-error'}`}
                          readOnly={loading}
                          theme="snow"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value}
                          modules={modules}
                        />

                        {Boolean(form.formState.errors.description_id) && (
                          <span className="text-14 text-danger">
                            {form.formState.errors.description_id.message}
                          </span>
                        )}
                      </div>
                    )}
                  />
                </div>
                <div className="col-12">
                  <Controller
                    control={form.control}
                    name="description_en"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <div style={{ marginBottom: 42 }}>
                        <label className="fw-600 text-dark">
                          Deskripsi (EN) <span className="text-danger">*</span>
                        </label>
                        <ReactQuill
                          className={`${Boolean(form.formState.errors.description_en) && 'form-error'}`}
                          readOnly={loading}
                          theme="snow"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value}
                          modules={modules}
                        />

                        {Boolean(form.formState.errors.description_en) && (
                          <span className="text-14 text-danger">
                            {form.formState.errors.description_en.message}
                          </span>
                        )}
                      </div>
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={form.control}
                    name="local_price"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextInput
                        disabled={loading}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        type="number"
                        isRequired={true}
                        label="Harga Paket Wisata Lokal"
                        isError={Boolean(form.formState.errors.local_price)}
                        errorMessage={
                          Boolean(form.formState.errors.local_price) &&
                          form.formState.errors.local_price.message
                        }
                      />
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={form.control}
                    name="foreign_price"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextInput
                        disabled={loading}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        type="number"
                        isRequired={true}
                        label="Harga Paket Wisata Asing"
                        isError={Boolean(form.formState.errors.foreign_price)}
                        errorMessage={
                          Boolean(form.formState.errors.foreign_price) &&
                          form.formState.errors.foreign_price.message
                        }
                      />
                    )}
                  />
                </div>
                <div className="col-12">
                  <Controller
                    control={form.control}
                    name="image"
                    render={({ field: { onChange, value } }) => (
                      <SingleImageUploader
                        required={true}
                        id="primaryImage"
                        label="Gambar Paket"
                        disabled={loading}
                        description="Rekomendasi ukuran gambar yang disarankan adalah 1280x720px"
                        onChange={onChange}
                        path="tenant/package/"
                        accept="image/*"
                        isError={Boolean(form.formState.errors.image)}
                        errorMessage={
                          Boolean(form.formState.errors.image) &&
                          form.formState.errors.image.message
                        }
                        value={value}
                      />
                    )}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default DetailPackage;
